import { Fragment, useEffect, useState, useMemo} from "react";
import { Button } from "@material-tailwind/react";
import {FilterFunction} from './FilterFunction';
import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  } from "@tanstack/react-table";
import { cardColors } from './constants';

export const BasicCapsTable = ({data,columns}) => {
  console.log(data)
  const [open, setOpen] = useState(1);
  const [openAgent, setOpenAgent] = useState(null);
  const [groupedData, setGroupedData] = useState(null);
  const [hiddenAgents, setHiddenAgents] = useState([]); // Used for hiding agents in accordion
  const [columnFilters,setColumnFilters] = useState([]);
  const [sorting, setSorting]=useState([]);
  const [filtering, setFiltering]=useState('');
  const defaultacademicyear = process.env.REACT_APP_DEFAULTACADEMICYEAR;
  
  function getCardColors(index) {
    const colorIndex = index % cardColors.length;
    const cardColor = cardColors[colorIndex];
    console.log(`getCardColors: index=${index}, colorIndex=${colorIndex}, color=`, cardColor);
    if (!cardColor) {
      console.error(`No color found for index ${index}, colorIndex ${colorIndex}`);
      return cardColors[0]; // Fallback to first color
    }
    return cardColor;
  }
  
  const dateFormatFn = (v_date) => {
    console.log(v_date)
    if (!v_date) return null; // Prevent undefined errors
    const dateObj = new Date(v_date)
    if (v_date.length <= 10)
      return dateObj.toLocaleDateString("en-GB", { month: "short", day: "2-digit", year: "2-digit" });
    else
      return dateObj.toLocaleDateString("en-GB",{ month: "short", day: "2-digit", year: "2-digit"} ) + " " + dateObj.toLocaleTimeString("en-GB", { hour:'numeric', minute:'numeric', hour12: true }).toUpperCase();
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
      </svg>
    );
  }
  function getRowColor(index) {
    return (index % 2 === 0) ? "bg-white":"bg-primary-500/10"
  }
  // const buttonCSS = "px-6 py-1 gap-x-4 rounded-lg text-lg font-nunito font-semibold \
  //                   border-blue-400 bg-white text-black normal-case \
  //                   hover:bg-primary-500 hover:text-white"
  const buttonCSS = "m-2 p-2 h-10 w-fit \
                      bg-transparent text-tertiary-300 \
                      hover:text-white hover:bg-primary-900 \
                      border-2 rounded-lg \
                      text-base font-bold tracking-widest normal-case items-center"

 
 
  const getDate = (dateStr) => {
    console.log(dateStr)
    console.log(typeof dateStr)
    if (typeof dateStr === 'string') {
      const match = dateStr.match(/^(\d{1,2}) (\w{3}) (\d{4})$/);
      console.log(match)
      if (match) {
          let [_, day, month, year] = match;
          const months = {
              Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
              Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
          };
          year = `${year}`; // Convert '25' → '2025'
          return `${year}-${months[month]}-${day.padStart(2, "0")}`;
      }
    }
    return null; // Invalid format
  };

  function getFirstAndLastDate(value) {
    // Helper function to convert 'dd MMM yy' → 'YYYY-MM-DD'
    const parseCustomDate = (dateStr) => {
        const match = dateStr.match(/^(\d{1,2}) (\w{3}) (\d{2})$/);
        if (match) {
            let [_, day, month, year] = match;
            const months = {
                Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
                Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
            };
            year = `20${year}`; // Convert '25' → '2025'
            return `${year}-${months[month]}-${day.padStart(2, "0")}`;
        }
        return null; // Invalid format
    };

    let dateCount = [];
    let firstDate = null;
    let lastDate = null;

    if (value) {
        const valueDates = value.split(",\n")
        dateCount = valueDates.length
        if ( dateCount > 0) {
          firstDate = !isNaN(Date.parse(valueDates[0])) ? valueDates[0] : null
          lastDate = dateCount > 1 && !isNaN(Date.parse(valueDates[dateCount - 1])) ? valueDates[dateCount - 1] : null;
        } else {
          const valueDate = !isNaN(Date.parse(value)) 
          if (valueDate) {
              firstDate = new Date(value.trim());
          } 
        }
    }
    return [firstDate, lastDate];
  };

  const activityStatus = (value, headerText = '') => {
    // Skip date processing for non-date columns
    const nonDateColumns = ['Round'];
    if (nonDateColumns.includes(headerText)) {
      return {
        fgcolor: "text-white",
        bgcolor: "bg-transparent",
        textcolor: "text-secondary-900",
        bordercolor: '',
        statusText: ''
      };
    }
    
    // Return default if value is null/undefined/empty
    if (!value || value === null || value === undefined) {
      return {
        fgcolor: "text-white",
        bgcolor: "bg-transparent",
        textcolor: "text-secondary-900",
        bordercolor: '',
        statusText: ''
      };
    }
    
    console.log(value)
      let statusText;
      let bgcolor = "bg-transparent";
      let fgcolor = "text-white";
      let textcolor = "text-secondary-900";
      let bordercolor = ''
      let effectiveDate;
      let endPart;
      let endDate;
      let diffDays;
      const today = new Date(); // default date in UTC
      const valueString = String(value || '');
      const valueTOform = (/\bto\b/.test(valueString)) // Value has /nto/n or simply to
      
      if (valueTOform) {
          [effectiveDate, endPart] = valueString.split(/\bto\b/).map(d => d.trim());
          // Split endPart into individual dates (handling extensions)
          let endDates = endPart.split("\n").map(d => {
            // Extract the date part (before any remark in parentheses)
            let datePart = d.split(" (")[0].trim();
            datePart = new Date(datePart);
            return datePart;
          });
            
          // Extract latest date without modifying time
          let latestEndDate = endDates.reduce((latest, current) => 
              current > latest ? current : latest, endDates[0]);

          endDate = latestEndDate; // Assign directly without creating a new Date object
          // Convert effectiveDate to Date object
      } else {// value can be any text string or an array of dates or a string with a single date.
          [effectiveDate, endDate] = getFirstAndLastDate(valueString)
          endDate = endDate? new Date(endDate): null
      } 
      effectiveDate = effectiveDate? new Date(effectiveDate): null
      
      if ((endDate) && (endDate instanceof Date) && !isNaN(endDate)) {
          diffDays = Math.floor((today - endDate) / (1000 * 60 * 60 * 24)); // Difference in days
          if (today <= endDate) { //endDate has not passed
              if (effectiveDate instanceof Date && !isNaN(effectiveDate)) {
                  if ((today >= effectiveDate) ) {
                      statusText = "Ongoing!";
                      bgcolor = "bg-warning-500"; // Orange for coming soon
                  };
                };
          } else if (today > endDate) { // endDate has passed.
                statusText = "Closed!";
                fgcolor = "text-danger-500";
                textcolor="text-gray-400";
                bordercolor = "border-danger-500"
          } else if (diffDays === 0) { // endDate is today
              statusText = "Due Today!";
              bgcolor = "bg-warning-500"; // Orange for coming soon
          } else if (diffDays < 0 && diffDays > -7) { // 7 days to due date
              statusText = "Due Soon!";
              bgcolor = "bg-info-900"; // Orange for coming soon
          };
      } else if (effectiveDate && effectiveDate instanceof Date && !isNaN(effectiveDate)) {
          diffDays = Math.floor((today - effectiveDate) / (1000 * 60 * 60 * 24)); // Difference in days
          console.log(diffDays)
          if (diffDays > 0) { // The date has passed by
              statusText = "Closed!";
              fgcolor = "text-danger-500";
              textcolor="text-gray-400";
              bordercolor = "border-danger-500"
          } else if (diffDays === 0) {
              statusText = "Due Today!";
              bgcolor = "bg-warning-900"; // Orange for Expiring today
          } else if (diffDays < 0 && diffDays > -7) { // 7 days to due date
              statusText = "Due Soon!";
              bgcolor = "bg-info-900"; // Orange for coming soon
          };
          // value is between start and end date
      };
    console.log(value, effectiveDate)
    console.log(fgcolor, bgcolor, textcolor,statusText)
    return {fgcolor, bgcolor, textcolor, bordercolor,statusText}
  };

  const showAllAgents = () => {
    setHiddenAgents([]);
  };

  const removeAgentFromView = (agent) => {
    setHiddenAgents((prevHiddenAgents) => {
      if (prevHiddenAgents.includes(agent)) {
        return prevHiddenAgents;
      }
      return [...prevHiddenAgents, agent];
    });
  };
  const handleAccordionClick = (agent) => {
    setOpen((openAgent)=>(openAgent === agent ? 0 : agent))
    setOpenAgent(agent)
  };
  const currentData = useMemo(() => 
    (openAgent && groupedData?.[openAgent]) || [], 
    [groupedData, openAgent]
  );
  const currentTable = useReactTable({
      data: currentData,
      columns,
      getCoreRowModel: getCoreRowModel(),
      getPaginationRowModel: getPaginationRowModel(),
      getSortedRowModel: getSortedRowModel(),
      getFilteredRowModel: getFilteredRowModel(),
      state: {
        columnFilters,
        sorting: sorting,
        globalFilter:filtering,
      },
      onColumnFiltersChange:setColumnFilters,
      onSortingChange:setSorting,
      onGlobalFilterChange:setFiltering,
  });


  // slice groupedData by pages for agents
  const agentsPerPage = 6;
  const [pageIndex, setPageIndex] = useState(0);
  const agentKeys = groupedData?Object.keys(groupedData): null;

  const visibleAgentKeys = useMemo(() => {
    return agentKeys ? agentKeys.filter(agent => !hiddenAgents.includes(agent)) : null;
  }, [agentKeys, hiddenAgents]);
  
  const paginatedAgentKeys = visibleAgentKeys ? visibleAgentKeys.slice(
                                          pageIndex * agentsPerPage,
                                          (pageIndex + 1) * agentsPerPage
                                        ): null;
  function defaultActivityStatus() {
    return {
      fgcolor: "",
      bgcolor: "bg-transparent",
      textcolor: "text-white",
      bordercolor: "text-secondary-900",
      statusText: "",
    };
  }
  const renderCapsCard = (row, index) => {
    const visibleCells = row.getVisibleCells();
    console.log(visibleCells)
    const colors = getCardColors(index);
    console.log(colors, index)
    return (
      <div className={`${colors.bg} border-2 ${colors.border}  
                       rounded-xl shadow-lg hover:shadow-xl 
                       transition-shadow duration-300 
                       p-5 space-y-3 h-full flex flex-col text-center
                       w-full max-w-full overflow-hidden min-w-0`}>
            {/* Cap Schedule Details */}
            {visibleCells.map((cell) => {
                  // Regular cell rendering
                  const rawValue = cell.getValue(); // Get raw value before rendering
                   // Get header text
                  const headerText = flexRender(cell.column.columnDef.header, cell.getContext());
                  console.log(headerText)
                  const { fgcolor, bgcolor, textcolor, bordercolor, statusText } = cell.column.columnDef.custom_getActivityStatus ? activityStatus(rawValue, headerText) : defaultActivityStatus();
                  const cellValue = flexRender(cell.column.columnDef.cell, cell.getContext());
                  if (!cellValue || cellValue === null || cellValue === undefined) return null
                  // Check if this is the first column
                  if (headerText === 'Notes') return null;
                  const isFirstColumn = visibleCells.indexOf(cell) === 0;
                  return (
                      <div key={cell.id} className={`border-b ${colors.border} 
                                                     pb-3 last:border-b-0 last:pb-0`}>
                        {colors[index]}
                        {headerText !== 'Round' && (
                          <div className={`font-bold ${colors.text} mb-2 text-center 
                                           ${colors.accent} rounded-lg py-2 px-3 
                                           text-sm md:text-base uppercase tracking-wide 
                                           font-nunito`
                                          }>
                              {headerText}
                          </div>
                        )} 
                        <div className={`${isFirstColumn ? 
                                  'text-tertiary-300 text-xl md:text-2xl font-bold' : 
                                  `${textcolor} text-base md:text-lg 
                                  font-medium`} font-nunito text-center break-words`}>
                              {flexRender(cell.column.columnDef.cell, cell.getContext())}
                          </div>
                        {statusText && (
                          <div className={`${bgcolor} ${fgcolor} border ${bordercolor} 
                                          mt-2 text-sm md:text-base font-bold rounded-md 
                                          px-3 py-1.5 shadow-sm font-nunito`}>
                            {statusText}
                          </div>
                        )}
                    </div>
                  );
              })}
              {/* Extra Notes */}
              {row.original?.capsch_notes && (  
                  <div className={`pt-3 mt-2 border-t ${colors.border} text-base md:text-lg 
                                    ${colors.text} bg-white/50 rounded-md p-3 font-nunito`}>
                    <span className="font-semibold">📌 Notes</span> {row.original.capsch_notes}
                  </div>
              )}
            
      </div>
    )
  };

  useEffect(() => {
    if (data) {
      const grouped = data.reduce((acc, row) => {
        const key = row.capsch_allocationboard;
        acc[key] = acc[key] || [];
        acc[key].push(row);
        return acc;
        }, {});
      setGroupedData(grouped);
    }
  },[data]);

  // Reset page index when hidden agents change to avoid empty pages
  useEffect(() => {
    if (visibleAgentKeys && visibleAgentKeys.length > 0) {
      const maxPageIndex = Math.floor((visibleAgentKeys.length - 1) / agentsPerPage);
      if (pageIndex > maxPageIndex) {
        setPageIndex(maxPageIndex);
      }
    } else if (visibleAgentKeys && visibleAgentKeys.length === 0) {
      setPageIndex(0);
    }
  }, [hiddenAgents, visibleAgentKeys]);
  

  return (
    <Fragment>
      
      <div className="bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 border-2 border-emerald-200 rounded-xl shadow-lg p-4 sm:p-5 md:p-6 mb-6">
        {/* Page Contet Text */}
        <div className="w-full mb-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4">
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-primary-900 tracking-tight">
              CAPS Schedules: AY202526
            </h2>
            {hiddenAgents.length > 0 && (
              <Button 
                className={`${buttonCSS} w-full sm:w-auto`} 
                onClick={showAllAgents}
              >
                View all Boards
              </Button>
            )}
        </div>

        <div className="w-full max-w-full overflow-x-hidden">
        {groupedData && paginatedAgentKeys && paginatedAgentKeys.length > 0 && paginatedAgentKeys.map(agent => {
            const schedules = groupedData?.[agent] ?? [];
            return (
              <Accordion  key={agent}  open={open === agent}>
                  <AccordionHeader   
                      icon={<Icon id={agent} open={open} />}
                      className={`${open === agent ? "bg-primary-100" : "bg-transparent"} shadow-md shadow-primary-200 p-2 min-h-14 w-full max-w-full`} 
                      onClick={() => handleAccordionClick(agent)}>
                        <div className="w-full max-w-full overflow-hidden">
                            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full min-w-0 gap-2 sm:gap-0">
                              <div className="flex gap-x-2 items-center min-w-0 flex-1 overflow-hidden text-lg md:text-xl">
                                  <label className="font-bold mt-1 mb-1 text-tertiary-300 
                                                    tracking-wide truncate font-nunito">{agent}</label>
                                  <span className= "p-0 m-0 bg-white-200 shadow-none flex-shrink-0 cursor-pointer touch-manipulation"
                                        onClick={(e) => { e.stopPropagation(); removeAgentFromView(agent); }}
                                        onKeyDown={(e)=> {
                                          if (e.key === 'Enter'|| e.key === " ") {
                                              removeAgentFromView(agent);
                                          }
                                        }}>
                                        <i className="fas fa-trash text-gray-500 text-base hover:text-red-500"></i>
                                  </span>
                              </div>
                              <div className="text-xs sm:text-sm text-primary-900 flex-shrink-0 sm:ml-2">
                                  Updated On: {schedules[0].capsch_modified_date ? dateFormatFn(schedules[0].capsch_modified_date) : 'N/A'}
                              </div>
                            </div>
                        </div>
                  </AccordionHeader>
                  <AccordionBody>
                    { schedules.every((row) => !row.capsch_round) ? (
                        <div className="text-center italic text-gray-500 p-2">
                          🕒 To Be Announced
                        </div>
                      ) : (
                        <div className="w-full max-w-full py-4 overflow-x-hidden">
                          <Swiper
                            modules={[Navigation, Pagination]}
                            spaceBetween={20}
                            slidesPerView={1}
                            slidesPerGroup={1}
                            navigation={true}
                            pagination={{ clickable: true }}
                            watchOverflow={false}
                            breakpoints={{
                              768: {
                                slidesPerView: 2,
                                slidesPerGroup: 2,
                                spaceBetween: 20,
                              },
                              1024: {
                                slidesPerView: 3,
                                slidesPerGroup: 3,
                                spaceBetween: 20,
                              },
                            }}
                            className="caps-schedule-carousel w-full pb-[3rem]"
                          >
                            {currentTable && currentTable.getRowModel().rows.map((row, index) => {
                              
                              return (
                                <SwiperSlide key={row.id} className="h-auto">
                                  <div className="w-full h-full">
                                    {renderCapsCard(row, index)}
                                  </div>
                                  
                                </SwiperSlide>
                              )
                            })}
                          </Swiper>
                          
                         
                        </div>
                      )
                    }
                  </AccordionBody>
              </Accordion>
          )})}
          <div>
            <Button className={`${buttonCSS}`}  onClick={() => setPageIndex(0)} disabled={pageIndex === 0}>First Page</Button>
            <Button className={`${buttonCSS}`}  onClick={() => setPageIndex(p => p - 1)} disabled={pageIndex === 0} >{"<<"}</Button>
            <Button className={`${buttonCSS}`}  onClick={() => setPageIndex(p => p + 1)} disabled={(pageIndex + 1) * agentsPerPage >= (visibleAgentKeys? visibleAgentKeys.length:0)}>{">>"}</Button>
            <Button className={`${buttonCSS}`}  onClick={() => setPageIndex(Math.floor((visibleAgentKeys? visibleAgentKeys.length:0) / agentsPerPage))}>Last Page</Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
